(() => {
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('click', event => {
    const arrow = event.target.closest('[data-rail-prev],[data-rail-next]');
    if (arrow) {
      const shelf = arrow.closest('[data-product-tabs]');
      const rail = [...shelf.querySelectorAll('.fm-product-rail')].find(el => !el.closest('[hidden]'));
      rail?.scrollBy({left: rail.clientWidth * (arrow.hasAttribute('data-rail-next') ? 1 : -1), behavior: reduced() ? 'instant' : 'smooth'});
    }
    const thumb = event.target.closest('[data-gallery-thumb]');
    if (thumb) {
      const wrap = thumb.closest('.fm-gallery-wrap');
      const gallery = wrap.querySelector('.lux-product__gallery');
      const slide = gallery.querySelector(`[data-gallery-index="${thumb.dataset.galleryThumb}"]`);
      gallery.scrollTo({left:slide.offsetLeft-gallery.offsetLeft,behavior:reduced()?'instant':'smooth'});
    }
  });
  const initGallery = wrap => {
    if(wrap.dataset.formReady)return;
    wrap.dataset.formReady='true';
    const gallery=wrap.querySelector('.lux-product__gallery');
    const slides=[...gallery.querySelectorAll('[data-gallery-index]')];
    let timer;
    gallery.addEventListener('scroll',()=>{
      cancelAnimationFrame(timer);
      timer=requestAnimationFrame(()=>{
        const index=Math.round(gallery.scrollLeft/gallery.clientWidth);
        wrap.querySelectorAll('[data-gallery-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.galleryThumb)===index)));
      });
    },{passive:true});
    wrap.closest('lux-product')?.addEventListener('change',event=>{
      const radio=event.target.closest('input[data-variant-image]');
      if(!radio?.dataset.variantImage)return;
      const target=slides.find(s=>s.querySelector('img').src.split('?')[0]===radio.dataset.variantImage.split('?')[0]);
      if(target)gallery.scrollTo({left:target.offsetLeft-gallery.offsetLeft,behavior:'instant'});
    });
  };
  document.querySelectorAll('.fm-gallery-wrap').forEach(initGallery);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.fm-gallery-wrap').forEach(initGallery));
  const initProductInfo = root => {
    if(root.dataset.ready)return;
    const nav=root.querySelector('[data-info-tabs]');
    const tabs=[...nav.querySelectorAll('button')];
    const panels=[...root.querySelectorAll('[data-info-panel]')];
    const select=index=>{
      tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;});
    };
    nav.setAttribute('role','tablist');nav.setAttribute('aria-label',root.getAttribute('aria-label'));
    tabs.forEach((tab,i)=>{
      tab.setAttribute('role','tab');
      panels[i].setAttribute('role','tabpanel');panels[i].setAttribute('aria-labelledby',tab.id);panels[i].tabIndex=0;
      tab.addEventListener('click',()=>select(i));
      tab.addEventListener('keydown',event=>{
        let next;
        if(event.key==='ArrowRight')next=(i+1)%tabs.length;
        if(event.key==='ArrowLeft')next=(i+tabs.length-1)%tabs.length;
        if(event.key==='Home')next=0;
        if(event.key==='End')next=tabs.length-1;
        if(next===undefined)return;
        event.preventDefault();select(next);tabs[next].focus();
      });
    });
    select(0);nav.hidden=false;root.dataset.ready='true';
  };
  document.querySelectorAll('[data-product-info]').forEach(initProductInfo);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-product-info]').forEach(initProductInfo));
})();
